let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("43mv2")).then(() => parcelRequire('36V1P'));